import React from 'react';
import { BreadcrumbRenderer, ProjectBreadcrumb } from '@atlassian/jira-breadcrumbs';
import { useBusinessEntity } from '@atlassian/jira-business-entity-common';
import { usePathParam } from '@atlassian/jira-platform-router-utils';
import { useProject } from '@atlassian/jira-router-resources-business-project-details';

export const Breadcrumb = () => {
	const [projectKeyParam] = usePathParam('projectKey');
	const { data: projectEntity } = useBusinessEntity();
	const { data: project } = useProject();

	const projectName = project?.name;
	const isSimplified = project?.isSimplified;
	const projectId = project?.id ? String(project.id) : projectEntity.id;
	const projectKey = project?.key ? String(project.key) : projectKeyParam;

	if (projectName == null || isSimplified == null || projectId == null || projectKey == null) {
		// Assure that we are not rendering a broken breadcrumb
		return null;
	}

	return (
		<ProjectBreadcrumb
			projectKey={projectKey}
			projectName={projectName}
			projectId={projectId}
			isSimplifiedProject={isSimplified}
		>
			<BreadcrumbRenderer />
		</ProjectBreadcrumb>
	);
};
